module.exports = __webpack_public_path__ + "img/im_scrollfeature_06@2x.3133996c.jpg";